import { ExportButtonConfiguration, ExportConfiguration, OptionsForExportInterface } from "@dandelion/core";

export const DEFAULT_EXPORT_OPTIONS: OptionsForExportInterface = {
    exportLabelForValues: false,
    exportLabelForVariableNames: false,
    csvSeparator: ';',
    splitColumnForSingleChoiceValues: false,
    splitColumnForMultipleChoiceValues: false,
    splitColumnForGroups: true,
    removeEmptyRows: false,
    removeEmptyColumns: false,
    removeCsvFilesWithoutRows: true,
    removeCsvFilesWithoutColumns: true,
}

export const DEFAULT_EXPORT_CONFIG: ExportConfiguration = {
    variableList: [],
    excludedVariables: [],
    crfList: ['core'],
    excludedCrfs: [],
    exportOptions: DEFAULT_EXPORT_OPTIONS,
};

export const ProsafeExportButtonConfigs: ExportButtonConfiguration[] = [
    {
        id: "Core",
        description: "Core data export",
        icon: "download-outline",
        exportConfiguration: DEFAULT_EXPORT_CONFIG
    },
];

